import React from 'react'

import { connect } from 'react-redux';
import { navigateTop } from '../routing/router-utils';
import { trackEvent } from '../analytics/tracking';
import PrimaryHeader from '../styleguide/PrimaryHeader';
import MediumButton from '../styleguide/MediumButton';
import BasicButton from '../styleguide/BasicButton';
import BagIcon from '../checkout/BagIcon';

import styles from './SwitchDispensaryWarning.module.css';

import PropTypes from 'prop-types'

const SwitchDispensaryWarning = ({ 
  itemDispensaryId,
  handleAddToCart,
  handleClose,
  dispensaryMap,
  cartDispensaryId
}) => {

  const [itemDispensary, setItemDispensary] = React.useState({});
  const [cartDispensary, setCartDispensary] = React.useState({});
 
  React.useEffect(() => {
    if (dispensaryMap && 
        dispensaryMap.get && 
        !(itemDispensary.id && cartDispensary.id)) {
      const newDispensary = dispensaryMap.get(itemDispensaryId);
      const currentDispensary = dispensaryMap.get(cartDispensaryId);
      if (newDispensary && currentDispensary) {
        setItemDispensary(newDispensary);
        setCartDispensary(currentDispensary);
      } else {
        trackEvent('error_setting_dispensary_warning',`${itemDispensaryId}`);
      }
    }
  }, [itemDispensaryId, cartDispensaryId, dispensaryMap, cartDispensary.id, itemDispensary.id, setItemDispensary, setCartDispensary]);

  return (
    <>
      <div className={styles.headerWrap}>
        <PrimaryHeader isCentered>
          <BagIcon key={itemDispensary.id} size="36"/> Start new bag? 
        </PrimaryHeader> 
      </div>
      <div className={styles.warning}>
        Your shopping bag contains item(s) from  
        <span onClick={() => navigateTop(`/dispensary/${cartDispensary.id}`)} className={styles.dispensaryLink}>
          {` ${cartDispensary.name}. `}
        </span>
      </div>   
      <div className={styles.warning}>
        Would you like to empty your bag and add this item from 
        <span onClick={() => navigateTop(`/dispensary/${itemDispensary.id}`)} className={styles.dispensaryLink}>
          {` ${itemDispensary.name} `}
        </span> instead?<sup>*</sup>
      </div>
      <div className={`${styles.warning} ${styles.footnote}`}>
        <sup>*</sup>State regulations limit dispensary orders to 1 per day.
      </div>
      <div className={styles.buttons}>
        <BasicButton text="Cancel" handleClick={handleClose} />
        <MediumButton text="New Bag" handleClick={handleAddToCart} />
      </div>
    </>
  );
}

SwitchDispensaryWarning.propTypes = {
  itemDispensaryId: PropTypes.string,
  handleAddToCart: PropTypes.func,
  handleClose: PropTypes.func,
  dispensaryMap: PropTypes.object, 
  cartDispensaryId: PropTypes.string
}

const mapStateToProps = (state) => {
  return {
    dispensaryMap: state.dispensaryMap, 
    cartDispensaryId: state.dispensaryId
  }
}

export default connect(mapStateToProps)(SwitchDispensaryWarning);
